import React, { useState } from 'react';
import './ContactModal.css';

export default function ContactModal({ open, onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('Question about a product');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!email || !message) {
      setError('Please provide your email and a short message.');
      return;
    }
    // Try to POST to /api/contact (Netlify function will use nodemailer)
    (async () => {
      try {
        const res = await fetch('/api/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, email, subject, message })
        });
        if (!res.ok) throw new Error('send-failed');
        onClose();
        // Optionally show a browser alert or toast
        alert('Thanks — your message was sent. We will reply shortly.');
      } catch (err) {
        console.warn('Contact API send failed, falling back to mailto', err);
        // Fallback to mailto
        const to = 'mashaba.enterprise2025@gmail.com';
        const mailSubject = encodeURIComponent(subject);
        const bodyLines = [
          `Name: ${name || '—'}`,
          `Email: ${email}`,
          '',
          message
        ];
        const mailBody = encodeURIComponent(bodyLines.join('\n'));
        const mailto = `mailto:${to}?subject=${mailSubject}&body=${mailBody}`;
        window.location.href = mailto;
        onClose();
      }
    })();
  };

  return (
    <div className="contact-modal-overlay" role="dialog" aria-modal="true">
      <div className="contact-modal">
        <button className="contact-modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h3>Contact Us</h3>
        <p className="muted">Send us a quick message and we'll get back to you.</p>
        <form onSubmit={handleSubmit} className="contact-form">
          <label>
            Your name
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Optional" />
          </label>
          <label>
            Your email
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
          </label>
          <label>
            Subject
            <input value={subject} onChange={(e) => setSubject(e.target.value)} />
          </label>
          <label>
            Message
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={5} required />
          </label>
          {error && <div className="contact-error">{error}</div>}
          <div className="contact-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">Send Message</button>
          </div>
        </form>
      </div>
    </div>
  );
}
